import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import moment from 'moment';
import { JwsPayload } from '../model/JwsPayload';
import { LogVisualizarDocumentoPrestacaoConta } from '../model/LogVisualizarDocumentoPrestacaoConta';


export class DocumentacaoGeralFiltro{
  idSetorDocumentacao = 0;
  descricao = '';

  pagina = 0;
  itensPorPagina = 10;
}


@Injectable({
  providedIn: 'root'
})
export class FinanceiroService { 

  financeiroURL = "";
  pixURL = "";
  documentacaoGeralURL = "";

  constructor(
    private httpClient: HttpClient
  ) {   
    this.financeiroURL = `${environment.apiUrl}/financeiros`;
    this.pixURL = `${environment.apiUrl}/pix`;
    this.documentacaoGeralURL = `${environment.apiUrl}/documentos-gerais`
  }

  espelhoPorSocio(idSocio: number, idEmpresa: number, datainicio: Date, dataFim: Date, token:any): Observable<Blob> {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',    
        'Authorization': `Bearer ${token}`        
      }),   
      params: new HttpParams()      
      .set('inicio', moment(datainicio).format('YYYY-MM-DD') )
      .set('fim', moment(dataFim).format('YYYY-MM-DD')),
      responseType: 'blob' as 'json'     
      
    };
    return this.httpClient.get<Blob>(`${this.financeiroURL}/espelho-por-socio/${idSocio}/${idEmpresa}`,httpHeaders);      
  }

  buscarDebitosPorIdSocio(idSocio: number, token: any){
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }),
    }
    return this.httpClient.get(`${this.financeiroURL}/debitos/${idSocio}`,httpHeaders);
  }

  criarPixPayLoad(jwsPayload: JwsPayload, token: any){
    const httpHeaders ={
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`
      })}
    return this.httpClient.post(`${this.pixURL}`, jwsPayload, httpHeaders);
  }


  documentacaoGeralPage(documentacaoGeralFiltro: DocumentacaoGeralFiltro, token: any){
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }),
      params: new HttpParams()
      .set('page', documentacaoGeralFiltro.pagina.toString())
      .set('size', documentacaoGeralFiltro.itensPorPagina.toString())
      .set('idSetorDocumentacao', documentacaoGeralFiltro.idSetorDocumentacao.toString())
      .set('descricao', documentacaoGeralFiltro.descricao)
    }
    return this.httpClient.get(`${this.documentacaoGeralURL}/resumo`, httpHeaders);
  }

  getDocumentacaoGeralById(id: number, idSocio: number, token: any){
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`   
      })
    }
    return this.httpClient.get(`${this.documentacaoGeralURL}/${id}/${idSocio}`, httpHeaders);
  }

  salvarLogVisualizacao(logVisualizarDocumentoPrestacaoConta: LogVisualizarDocumentoPrestacaoConta, token: any): Observable<any>{
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpClient.post(`${this.documentacaoGeralURL}/logs-visualizacoes-documentos`, logVisualizarDocumentoPrestacaoConta, httpHeaders);
  } 
}